import { Component } from '@theme/component';

class NSBReveal extends Component {
  #observer;
  #animations = [];
  #controller;
  #active = false;
  #motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.#motion.addEventListener('change', () => {
      if (this.#motion.matches) {
        this.#stop();
      }
    }, { signal: this.#controller.signal });
    if (window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    this.#observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry.isIntersecting) {
        this.#active = false;
        this.#stop();
        return;
      }
      if (entry.intersectionRatio < 0.16 || this.#active || this.#motion.matches) return;
      this.#active = true;
      this.#stop();
      const subjects = Array.from(this.children).filter((element) => element instanceof HTMLElement);
      subjects.forEach((element, index) => {
        if (!element.animate) return;
        this.#animations.push(element.animate([
          { opacity: 0, transform: 'translateY(32px)' },
          { opacity: 1, transform: 'translateY(0)' },
        ], {
          duration: 900,
          delay: index * 110,
          fill: 'backwards',
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        }));
      });
    }, { threshold: [0, 0.16], rootMargin: '0px 0px -10% 0px' });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.#stop();
    this.#controller?.abort();
    this.#active = false;
  }

  #stop() {
    this.#animations.forEach((animation) => animation.cancel());
    this.#animations = [];
  }
}

if (!customElements.get('nsb-reveal')) customElements.define('nsb-reveal', NSBReveal);
